import { createContext } from 'use-context-selector';
import { CommunicationProviderState } from './types';
import { defaultCommunicationProviderState } from './defaultState';

const CommunicationContext = createContext<CommunicationProviderState>(defaultCommunicationProviderState());

export { CommunicationContext };
